var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAtSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#39abf2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M24,32H16A16,16,0,0,1,4.688,4.688,16,16,0,0,1,32,16v2.288a5.75,5.75,0,0,1-1.618,4.038A5.509,5.509,0,0,1,26.4,24a5.938,5.938,0,0,1-4.736-2.353A7.9,7.9,0,0,1,16,24a8,8,0,1,1,8-8v2.288A2.589,2.589,0,0,0,26.4,20.8a2.589,2.589,0,0,0,2.4-2.512V16A12.971,12.971,0,0,0,16,3.2,12.971,12.971,0,0,0,3.2,16,12.971,12.971,0,0,0,16,28.8h8V32ZM16,11.2A4.8,4.8,0,1,0,20.8,16,4.806,4.806,0,0,0,16,11.2Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAtSymbol);
export default __webpack_public_path__ + "static/media/icon-at-symbol.a02ce4c0a006e69721246ae6da673ae0.svg";
export { ForwardRef as ReactComponent };